var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdExitFullScreen16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "16 5 11 5 11 0 12 0 12 4 16 4 16 5",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "5 5 0 5 0 4 4 4 4 0 5 0 5 5",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "12 16 11 16 11 11 16 11 16 12 12 12 12 16",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "5 16 4 16 4 12 0 12 0 11 5 11 5 16",
    className: "aw-theme-iconOutline",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdExitFullScreen16);
export default __webpack_public_path__ + "static/media/cmdExitFullScreen16.b0e6dbea467adb7437b86b521e7ef845.svg";
export { ForwardRef as ReactComponent };